import { forwardRef, ForwardRefExoticComponent, RefAttributes } from 'react'
import { Switch, SwitchProps } from '@mui/material'
import { FieldInputProps, useField } from 'formik'

// Override type of material-ui, cause formik requires name to be non-optional.
type Props = Omit<SwitchProps, keyof FieldInputProps<boolean>> & {
  name: string
}

export const SwitchInput: ForwardRefExoticComponent<Omit<Props, 'ref'> & RefAttributes<HTMLButtonElement>> = forwardRef(
  ({ name, ...props }: Props, ref: React.Ref<HTMLButtonElement>) => {
    const [field] = useField<boolean>(name)

    return <Switch {...props} {...field} checked={field.value} ref={ref} />
  }
)
